import '../css/sky-footer.scss';

document.addEventListener('DOMContentLoaded', function () {
    var newsletterForm = document.getElementById('newsletter-form');
    if (newsletterForm) {
        var mailchimpHandlerPath = document.querySelector('.footer-mailchimp-handler-path').dataset.path;
        var turnstileVerifyPath = '/wp-content/themes/storefront-child/turnstile-verify.php'; // Update path as needed

        // Store the widget ID globally for the newsletter form
        var turnstileWidgetId = null;

        // Initialize Turnstile when the script loads
        window.onloadTurnstileCallbackNewsletter = function () {
            // Render the invisible Turnstile widget for newsletter form
            turnstileWidgetId = turnstile.render('#turnstile-container-newsletter', {
                sitekey: '0x4AAAAAABV0qEPXLQlnnxe-',
                mode: 'invisible',
                callback: function (token) {
                    // This is called when a token is successfully generated
                    document.getElementById('turnstile-token-newsletter').value = token;
                },
                'error-callback': function () {
                    console.error('Turnstile error occurred');
                    handleError(document.getElementById('skyfooter-form-message'), 'Security verification failed. Please refresh and try again.');
                },
                'expired-callback': function () {
                    // Reset the widget when it expires
                    turnstile.reset(turnstileWidgetId);
                }
            });
        };

        // Check if Turnstile is already loaded
        if (window.turnstile) {
            window.onloadTurnstileCallbackNewsletter();
        } else {
            // Wait for the global script to load
            var checkInterval = setInterval(function () {
                if (window.turnstile) {
                    clearInterval(checkInterval);
                    window.onloadTurnstileCallbackNewsletter();
                }
            }, 100);
        }

        newsletterForm.addEventListener('submit', function (e) {
            e.preventDefault();
            var form = e.target;
            var messageDiv = document.getElementById('skyfooter-form-message');
            var submitButton = form.querySelector('button[type="submit"]');
            var originalButtonText = submitButton.textContent;

            submitButton.disabled = true;
            submitButton.textContent = 'Processing...';
            messageDiv.textContent = '';

            // Get the current Turnstile token
            var turnstileToken = turnstile.getResponse(turnstileWidgetId);

            if (!turnstileToken) {
                // If no token, execute Turnstile challenge
                turnstile.execute(turnstileWidgetId);

                // Wait for the token to be generated
                var tokenCheckInterval = setInterval(function () {
                    turnstileToken = turnstile.getResponse(turnstileWidgetId);
                    if (turnstileToken) {
                        clearInterval(tokenCheckInterval);
                        processFormSubmission(turnstileToken);
                    }
                }, 100);

                // Timeout after 10 seconds
                setTimeout(function () {
                    clearInterval(tokenCheckInterval);
                    if (!turnstileToken) {
                        handleError(messageDiv, 'Security verification timed out. Please try again.');
                        submitButton.disabled = false;
                        submitButton.textContent = originalButtonText;
                    }
                }, 10000);
            } else {
                // Token already exists, proceed with submission
                processFormSubmission(turnstileToken);
            }

            function processFormSubmission(token) {
                verifyTurnstile(token)
                    .then(() => {
                        // If Turnstile verification is successful, proceed with form submission
                        var formData = new FormData(form);
                        formData.append('turnstile-token', token);

                        return fetch(mailchimpHandlerPath, {
                            method: 'POST',
                            body: formData,
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest'
                            }
                        });
                    })
                    .then(response => response.json())
                    .then(data => {
                        if (data.status === 'success') {
                            messageDiv.innerHTML = '<p class="alert alert-success h4">' + data.message + '</p>';
                            form.style.display = 'none';
                        } else {
                            messageDiv.innerHTML = '<p class="alert alert-warning h4">' + data.message + '</p>';
                            // Reset Turnstile widget for retry
                            turnstile.reset(turnstileWidgetId);
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        handleError(messageDiv, error.message);
                        // Reset Turnstile widget on error
                        turnstile.reset(turnstileWidgetId);
                    })
                    .finally(() => {
                        submitButton.disabled = false;
                        submitButton.textContent = originalButtonText;
                    });
            }
        });
    }

    function verifyTurnstile(token) {
        const formData = new FormData();
        formData.append('turnstile-token', token);

        return fetch(turnstileVerifyPath, {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
            .then(response => response.json())
            .then(data => {
                if (!data.success) {
                    throw new Error(data.message);
                }
            });
    }

    function handleError(messageDiv, errorMessage) {
        let userMessage = 'An error occurred. Please try again later.';

        if (errorMessage.includes('Suspected unusual traffic')) {
            userMessage = 'We detected unusual traffic from your network. Please try again later or from a different network.';
        } else if (errorMessage.includes('Security verification failed')) {
            userMessage = 'Security verification failed. Please refresh the page and try again.';
        } else if (errorMessage.includes('Security check incomplete')) {
            userMessage = 'Security check incomplete. Please ensure JavaScript is enabled and try again.';
        } else if (errorMessage.includes('timed out')) {
            userMessage = 'The security check timed out. Please try again.';
        } else if (errorMessage.includes('Invalid request')) {
            userMessage = 'There was a problem with your request. Please refresh the page and try again.';
        }

        messageDiv.innerHTML = '<p class="alert alert-warning h4">' + userMessage + '</p>';
    }
});